import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, styled, SxProps, Typography } from '@mui/material'
import React from 'react'
import { colors } from '../../constants/colors';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

type dataType = {
    value: string;
    label: string;
    sx?: SxProps;
    renderAfter?: React.ReactNode;
}
type Props = {
    sx?: SxProps;
    heading?: string;
    dataList: dataType[];
    defaultValue?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    row?: boolean;
    disabled?: boolean;
    labelClassName?: string;
    between?: boolean;
}

const MainRadioGroup = styled(RadioGroup)(({ theme }) => ({
    '& .Mui-checked': {
        color: theme.palette.subPrimary || colors.subPrimary,
        '& .MuiSvgIcon-root': {
            // backgroundColor: 'blue',
        }
    },
}))

const RadioCustom: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const { heading, defaultValue, dataList, value, onChange, sx, className, row, disabled } = props;
    return (
        <Box className={className} sx={{ ...sx, width: "100%" }}>
            <FormControl
                sx={{ width: "100%" }}
            >
                {heading &&
                    <FormLabel
                        id="radio-buttons-group-label">
                        <Typography variant='h6'>
                            {heading}
                        </Typography>
                    </FormLabel>}
                <MainRadioGroup
                    // sx={{
                    //     width:'100%',
                    //     flexWrap: "nowrap",
                    //     '& .MuiFormControlLabel-root': {
                    //         width: "100% !important"
                    //     }
                    // }}
                    row={row}
                    aria-labelledby="radio-buttons-group-label"
                    defaultValue={defaultValue}
                    name="radio-buttons-group"
                    value={value}
                    onChange={onChange}
                >
                    {dataList.map((list, index: number) => {
                        return (
                            <FormControlLabel
                                disabled={disabled}
                                key={index + 1}
                                color={colors.subPrimary}
                                sx={{
                                    maxWidth: "100%",
                                    ...list.sx,
                                    width: 'auto',  // Ensure full width
                                    minWidth: "auto",
                                    flex: list.renderAfter ? '1' : "0",
                                    // flex: '1 1 auto', // Allow flexbox to distribute space properly
                                    whiteSpace: "nowrap",
                                    '& .MuiFormControlLabel-root': {
                                        width: '100% !important',
                                    }
                                }}
                                value={list.value}
                                control={<Radio disableRipple sx={{
                                    '&.Mui-checked': {
                                        color: colors.subPrimary,
                                    },
                                }} />}
                                componentsProps={{
                                    typography: {
                                        sx: {
                                            width: '100%',
                                            whiteSpace: 'nowrap'
                                        }
                                    }
                                }}
                                label={
                                    <div className={clsx('w-full flex gap-4 items-center', {
                                        'justify-between': props.between,
                                        'justify-start': !props.between,
                                    })}>
                                        <Typography className={props.labelClassName} variant='body1' sx={{ flex: 1 }}>
                                            {t(list.label)}
                                        </Typography>
                                        {list.renderAfter && (
                                            <div className='w-full'>
                                                {list.renderAfter}
                                            </div>
                                        )
                                        }
                                    </div>
                                }
                            />
                        )
                    })}
                </MainRadioGroup>
            </FormControl>
        </Box >
    )
}

export default RadioCustom